<template>
  <div>
    <Loading is-full-page :active="fetching" ></Loading>

    <div class="mb-3">
      <a-button
        type="primary"
        icon="upload"
        @click="showUploadForm = true"
      >
        {{ $t('settings.uploadImage') }}
      </a-button>
    </div>

    <a-menu mode="horizontal" class="mb-3" :default-selected-keys="[type]" @click="onMenuChange">
      <a-menu-item
        v-for="(item, key) in types"
        :key="key"
      >
        {{ item.title }}
      </a-menu-item>
    </a-menu>

    <!-- <div class="mb-5">
      <a-button
        type="primary"
        icon="upload"
        @click="showUploadForm = true"
      >
        {{ $t('settings.uploadImage') }}
      </a-button>
    </div> -->

    <a-empty v-if="!fetching && !imageList.length && !error" />
    <AResult
      v-if="error"
      :status="String(error.status || 500)"
      :title="error.status || 500"
      :sub-title="error.message"
    />

    <a-row type="flex" :gutter="[24,24]">
      <a-col
        v-for="image in imageList"
        :xs="24"
        :md="12"
        :xl="8"
        :key="image.image_id"
        class="image-col"
      >
        <div class="image-item">
          <div class="image-action">
            <a-popconfirm
              title="Are you sure want to delete this item?"
              @confirm="remove(image)"
            >
              <a-button icon="delete" size="small" type="danger"></a-button>
            </a-popconfirm>
          </div>
          <img slot="cover" :src="`${image.url}?tr=w-600`" />
        </div>
      </a-col>
    </a-row>

    <a-modal
      :visible="showUploadForm"
      :title="$t('settings.uploadImage')"
      @cancel="showUploadForm = false"
      :width="375"
      :footer="false"
    >
      <UploadImageForm
        v-if="showUploadForm"
        :types="Object.values(types).map(item => ({ value: item.id, title: item.title }))"
        :selectedType="activeType.id"
        @saved="saved()"
      />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import UploadImageForm from '@/components/Image/UploadImageForm'

const DEFAULT_TYPE = 'logo'

export default {
  name: 'SettingStore',
  components: {
    Loading,
    UploadImageForm,
  },
  data: function () {
    return {
      error: false,
      showUploadForm: false,
      types: {
        logo: {
          id: 1,
          title: this.$t('settings.logo'),
        },
        banner: {
          id: 2,
          title: this.$t('settings.banner'),
        },
        'category-banner': {
          id: 3,
          title: this.$t('settings.categoryBanner'),
        },
        'reseller-banner': {
          id: 12,
          title: this.$t('settings.resellerBanner'),
        },
      },
    }
  },
  mounted() {
    this.fetch()
  },
  computed: {
    ...mapState('settings/store', [
      'images',
      'fetching',
    ]),
    type: function () {
      return this.$route.params.type || DEFAULT_TYPE
    },
    activeType: function() {
      return this.types[this.type]
    },
    imageList: function() {
      return this.images.filter(image => image.type === this.activeType.id)
    },
  },
  methods: {
    onMenuChange({ key }) {
      this.$router.push(`/settings/store/${key}`)
    },
    fetch() {
      this.$store.dispatch('settings/store/GET_BANNER', { type: this.type })
        .catch(err => {
          this.error = err
        })
    },
    remove(item) {
      this.$store.dispatch('settings/store/REMOVE_BANNER', {
        id: item.ref_id,
      })
        .then((r) => {
          console.log({ r })
          this.fetch()
        })
    },
    saved() {
      this.showUploadForm = false
      this.fetch()
    },
  },
  watch: {
    // type: {
    //   immediate: true,
    //   handler: function(val) {
    //     this.error = false
    //     this.fetch()
    //   },
    // },
  },
}
</script>

<style scoped lang="scss">
img {
  max-width: 100%
}

.image-col {
  display: flex;
  justify-items: center;
}

.image-action {
  position: absolute;
  top: .5rem;
  right: .5rem;
  opacity: .6;
  transition: all .2s ease-in-out;
}

.image-item {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #efefef;

  img {
    max-width: 100%;
    max-height: 100%;
  }

  &:hover {
    .image-action {
      opacity: 1;
    }
  }
}
</style>
